interface GroupLevelDisplayProps {
  level: number;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

export default function GroupLevelDisplay({ 
  level, 
  size = 'md',
  showLabel = true 
}: GroupLevelDisplayProps) {
  const sizeClasses = {
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-10 h-10 text-base'
  };

  const getLevelColor = (level: number) => {
    if (level >= 9) return 'from-purple-500 to-pink-500';
    if (level >= 7) return 'from-blue-500 to-purple-500';
    if (level >= 5) return 'from-green-500 to-blue-500';
    if (level >= 3) return 'from-yellow-500 to-green-500';
    return 'from-gray-400 to-gray-500';
  };

  const getLevelTitle = (level: number) => {
    if (level >= 9) return 'Legendary';
    if (level >= 7) return 'Expert';
    if (level >= 5) return 'Advanced';
    if (level >= 3) return 'Intermediate';
    return 'Beginner';
  };

  return (
    <div className="flex items-center gap-2">
      <div
        className={`${sizeClasses[size]} bg-gradient-to-br ${getLevelColor(level)} rounded-full flex items-center justify-center text-white font-bold shadow-sm`}
        title={`Level ${level} - ${getLevelTitle(level)}`}
      >
        {level}
      </div>
      {showLabel && (
        <span className="text-sm text-gray-600 font-medium">
          Level {level}
        </span>
      )}
    </div>
  );
}
